import {Component, OnInit} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {Border, SeriesLabels} from "@progress/kendo-angular-charts";
import {DtoManagementSalesGoal} from "./models/DtoManagementSalesGoal";
import {DtoManagementSalesGoalBaseItems} from "./models/DtoManagementSalesGoalBaseItems";
import {ManagementSalesGoalService} from "./management-sales-goal.service";

@Component({
    selector: 'app-management-sales-goal',
    template: require('./management-sales-goal.component.html'),
    styles: [require('./management-sales-goal.component.css')]
})

@AutoUnsubscribe()
export class ManagementSalesGoalComponent implements OnInit {
    periodDisabled: boolean;
    subSalesgroupDisabled: boolean;
    data: DtoManagementSalesGoal;
    filterHeaderConfig: PageHeaderBarConfig;
    periodItems: Array<{ text: string, value: number }> = [
        {text: "Deze week", value: 1},
        {text: "Deze maand", value: 2},
        {text: "Dit jaar", value: 3},
        {text: "Laatste 2 jaar", value: 4},
        {text: "Variabele periode", value: 5}
    ];
    baseItems: DtoManagementSalesGoalBaseItems;
    filterForm: FormGroup;
    legendBorder: Border = {
        color: '#bababa',
        dashType: "solid",
        width: 1
    };
    public seriesLabels: SeriesLabels = {
        visible: true,
        padding: 3,
        font: '12px Arial, sans-serif',
        content: e => {return (e.percentage * 100).toFixed(0) + '%'}
    };
    public goalSerieColors: ['#12484', '#000'];
    pshbConfigBrutoSales: PageSubheaderBarConfig;
    pshbConfigNettoSales: PageSubheaderBarConfig;
    pshbTreatmentGoals: PageSubheaderBarConfig;
    pshbArticleGoals: PageSubheaderBarConfig;

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ss: SharedService,
                private sds: SharedDataService,
                private ds: ManagementSalesGoalService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'management', isLastStep: false },
            { text: 'behandelingen & verkoop', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'INSTELLINGEN',
            buttonDefinition: [
                {
                    description: 'RESULTATEN',
                    clickEventType: 'search',
                    isSmall: false
                }
            ]
        };

        this.pshbConfigBrutoSales = {
            title: 'OMZET INCLUSIEF BTW',
            buttonDefinition: []
        };
        this.pshbConfigNettoSales = {
            title: 'OMZET EXCLUSIEF BTW',
            buttonDefinition: []
        };
        this.pshbTreatmentGoals = {
            title: 'DOELSTELLING BEHANDELINGEN',
            buttonDefinition: []
        };
        this.pshbArticleGoals = {
            title: 'DOELSTELLING VERKOOP',
            buttonDefinition: []
        };

        this.filterForm = this.fb.group({
            employeeId: 0,
            userId: 0,
            periodId: 2,
            from: null,
            untill: null
        });


        this.filterForm.get('periodId').valueChanges.subscribe(newVal => {
            this.setFilterPeriod(newVal);
            this.clearData();
        });

        this.filterForm.get('userId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('employeeId').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('from').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.filterForm.get('untill').valueChanges.subscribe(newVal => {
            this.clearData();
        });

        this.setFilterPeriod(2);

        this.ds.getSalesGoalBaseItems().subscribe((res: DtoManagementSalesGoalBaseItems) => {
            this.baseItems = res;
            this.loadData();
        });
    }

    clearData() {
        this.data = null;
    }

    loadData() {
        this.data = null;
        this.ds.getSalesGoal({
            userId: this.filterForm.get('userId').value,
            from: this.filterForm.get('from').value,
            employeeId: this.filterForm.get('employeeId').value,
            untill: this.filterForm.get('untill').value
        }).subscribe((res: DtoManagementSalesGoal) => {
            this.data = res;
        });
    }

    setFilterPeriod(periodKind: number) {
        if (periodKind == 1) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addDaysToDate(this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()), 6) });
        } else if (periodKind == 2) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfMonth(this.ss.getCurrentDate()) });
        } else if (periodKind == 3) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate()) });
        } else if (periodKind == 4) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addYearsToDate(this.ss.getLastDayOfYear(this.ss.getCurrentDate()), 1) });
        } else if (periodKind == 5) {
            this.periodDisabled = false;
        }
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/sales-goal/management-sales-goal.component.ts